import './main.scss';
//----------------  START ----------------  ANUGLAR REQUIRED LIBRARIES
import "babel-polyfill";
import './modules/utils/polifills';
import * as angular from 'angular';
import 'angular-route';
import 'angular-ui-bootstrap';
import 'angular-touch';
import 'angular-animate';
import 'angular-material';
import 'angular-aria';
import 'dateformat';
import 'popper.js'
import 'bootstrap';
import 'datatables';
import 'md-data-table';
import 'md-data-table';

//----------------  START ---------------- REQUIRED MODULES
import {UserAuthorityService} from 'modules/router/service/GrantedAuthorityService';
//----------------  START ----------------  REQUIRED LIBRARIES
import 'zone.js';
import 'reflect-metadata';

import {ApplicationModuleName, MainModuleName, RouterModuleName} from "./modules/utils/names/requiredModulesNames";
import {CONFIGURATION_INITIALIZER} from "initializers/ActiveBrandInitializer";
import {Principle} from "modules/brand_service/model/Principle";
import {ModulesServiceInstance} from "modulesService";
import {RestrictedRouteModuleConfiguration} from "modules/router/model/UserPermission";
import {RouterModulesConfigurations} from "modules/router/RouterModuleConfiguration";
import {removeDuplicatesAndEmptyStrings} from "modules/utils/StringUtils";
import {collect} from "modules/utils/CollectionUtils";
// ---------------- END ---------------- ANUGLAR REQUIRED LIBRARIES
//----------------  END ----------------  REQUIRED LIBRARIES
export declare var PRINCIPLE: Principle;

export declare var USER_AUTHORITY_SERVICE: UserAuthorityService;

(async function () {
    PRINCIPLE = await CONFIGURATION_INITIALIZER.getPrinciple();
    USER_AUTHORITY_SERVICE = new UserAuthorityService(PRINCIPLE);

    const getPermittedModulesConfigurations = (): RestrictedRouteModuleConfiguration[] => {
        const permittedControllerModules =
            USER_AUTHORITY_SERVICE.getPermittedModulesConfigurations();
        return [RouterModulesConfigurations, ...permittedControllerModules]
    }

    const importPermittedModules = async (): Promise<string[]> => {
        const permittedModulesConfigurations = getPermittedModulesConfigurations();
        const permittedModuleNames = permittedModulesConfigurations
            .map(moduleConfiguration => {
                return moduleConfiguration.getAllModulesNames();
            })
            .reduce(collect, []);
        const uniqueModuleNames = removeDuplicatesAndEmptyStrings(permittedModuleNames);
        await ModulesServiceInstance.importAllModules(uniqueModuleNames);
        return uniqueModuleNames;
    };

    const importedModules = await importPermittedModules();

    angular.module(ApplicationModuleName, [
        MainModuleName,
        RouterModuleName
    ]);

    // setAngularJSGlobal(angular);
    // platformBrowserDynamic().bootstrapModule(ApplicationModule);
    angular.bootstrap(document, importedModules, {strictDi: true})
})();


declare global {
    interface Array<T> {
        diff: (other: T[]) => T[];
        max: () => T;
        min: () => T;
    }

    interface Date {
        fromDuration: (durationString: string) => string;
        isValid: () => boolean;
    }

    interface String {
        replaceAll: (search: string, replacement: string) => string;
    }

    interface Object {
        fromEntries<T>(o: [string, T[]][]): { [s: string]: T[] }
    }

}
